import { LineEndingType } from "@evergis/api";
import { Coordinates } from "@evergis/sgis/es/baseTypes";
import { Arc } from "@evergis/sgis/es/renders/Arc";

import { LineMiterRender } from "./LineMiterRender";

export class CircleLineMiterRender extends LineMiterRender {
  get usageSize() {
    return this.miterSize + this.strokeWidth * 3;
  }

  createRings([x, y]: Coordinates, xMultiplier: number): Coordinates[][] {
    return [[[x + (this.miterSize / 2 + this.strokeWidth) * xMultiplier, y]]];
  }

  createRender(miterRings: Coordinates[][]) {
    const isFilled = this.kind === LineEndingType.FilledCircle;

    return new Arc(miterRings[0][0], {
      fillColor: isFilled ? this.color : "transparent",
      radius: this.miterSize / 2,
      strokeColor: this.color,
      strokeWidth: this.strokeWidth,
    });
  }
}
